import { Phone, Mail, ArrowUp } from "lucide-react";
import { CONTACT } from "../data";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-black px-5 py-16 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img src="/ftc-logo.png" alt="FTC Automotive" className="h-14 w-14 rounded-md object-cover" />
              <span className="font-display text-lg tracking-[0.22em] chrome-text">FTC AUTOMOTIVE</span>
            </div>
            <p className="mt-5 font-body text-sm leading-relaxed text-neutral-500">
              Bristol's heavyweight independent automotive specialist. Precision repairs, zero waffle, maximum performance.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <span className="font-accent text-[11px] uppercase tracking-[0.3em] text-neutral-600">Direct Comms</span>
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 font-display text-2xl chrome-text-soft transition-opacity hover:opacity-80 md:text-3xl">
              <Phone className="h-5 w-5 text-[#ffb000]" /> {CONTACT.phone}
            </a>
            <a href={CONTACT.emailHref} className="flex items-center gap-3 font-body text-base text-neutral-300 transition-colors hover:text-white">
              <Mail className="h-4 w-4 text-neutral-500" /> {CONTACT.email}
            </a>
            <span className="mt-1 font-body text-sm text-neutral-500">{CONTACT.area}</span>
          </div>

          <button
            data-testid="footer-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex h-14 w-14 items-center justify-center rounded-full border border-white/15 text-white transition-colors duration-300 hover:border-[#ffb000]/60 hover:text-[#ffb000]"
            aria-label="Back to top"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <span className="font-accent text-xs uppercase tracking-[0.2em] chrome-text-soft">
            © {year} FTC Automotive
          </span>
          <span className="font-body text-xs text-neutral-600">
            IMI Level 1–3 Qualified · Official Master Member · Bristol BS5
          </span>
        </div>
      </div>
    </footer>
  );
};
